<template>
  <portal to="referral-banner">
    <section
      v-if="showReferralBanner && !$_fsaHsaPromo_isActiveFsaHsaPromo"
      id="fsa-has-store-banner"
      class="md:tw-px-7 tw-items-center tw-flex tw-justify-center tw-h-auto tw-py-5 tw-w-screen tw-text-white tw-font-atten-medium"
      :class="[
        'tw-px-2 tw-relative tw-top-0 tw-left-0 tw-flex',
        isOnboardingRedesign ? 'tw-bg-[#ECE8F5] tw-z-[600]' : 'tw-bg-lavender-purple tw-z-[999]'
      ]"
    >
      <div class="tw-flex tw-items-center lg:tw-max-w-max">
        <div class="tw-relative tw-flex tw-items-center tw-justify-center tw-mr-5">
          <svg
            class="tw-w-[66px]"
            width="80"
            height="80"
            viewBox="0 0 67 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="33.4062"
              cy="33.707"
              r="31.0771"
              fill="#312849"
              stroke="white"
              stroke-width="3.34162"
            />

            <defs>

              <clipPath id="clip0_164_3985">
                <rect
                  width="17.0563"
                  height="16.881"
                  fill="white"
                  transform="translate(20.7031 17.9609) rotate(-9.29938)"
                />
              </clipPath>
            </defs>
          </svg>
          <div
            class="
               tw-w-[3rem]
               tw-mb-0
               tw-absolute
               tw-bottom-[4px]
               tw-left-[18px]
"
          >
            <img
              src="@/assets/images/svg/sticker.svg"
              alt="sticker"
              class="tw-mr-5"
            >
            <p
              class="tw-font-bold tw-text-[0.7rem] tw-rotate-[-20deg] tw-text-white"
            >
              ${{ onboardingPatient?.referraldiscountamount || '75' }} Off
            </p>
          </div>
        </div>

        <div>
          <h3 class="tw-text-lg md:tw-text-2xl tw-text-[#312849] tw-m-0">
            Referral code activated!
          </h3>
          <p
            class="tw-mt-[2px] tw-text-sm md:tw-text-2xl tw-m-0 tw-text-[#312849] tw-font-atten"
          >
            <span class="tw-text-[#A3A3A3]">*Discount applied at checkout</span>
          </p>
        </div>
      </div>
    </section>
  </portal>
</template>

<script>
import { mapState } from 'vuex';
import $cookies from '@/utils/cookies';
import { UsersService } from '@/services/users.service';
import { fsaHsaPromoMixin } from '@/mixins/fsaHsaPromo';
export default {
  mixins: [fsaHsaPromoMixin],
  data() {
    return {
      referralToken: '',
      showReferralBanner: false,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
  },
  async mounted() {
    // Referral code
    if ($cookies.get('referralToken') && !$cookies.get('promocodeExistingID')) {
      try {
        if (
          $cookies.get('referralToken') &&
          ($cookies.get('promocodeExistingID') || $cookies.get('promocode'))
        ) {
          $cookies.remove('promocode');
          $cookies.remove('promocodeExistingID');
        }
        const checkToken = await UsersService.checkReferralToken({
          referralcode: $cookies.get('referralToken'),
        });
        if (checkToken.message == 'success') {
          this.referralToken = $cookies.get('referralToken');
          if (this.isOnboardingRedesign) {
            this.showReferralBanner = true;
          }
        } else {
          this.showReferralBanner = false
        }
      } catch (err) {
        this.showReferralBanner = false
      }
    }
  },
}

</script>